import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
/* @ts-expect-error bender url */
import liveChatBg from 'bender-url!../../img/livechat-background.svg';
/* @ts-expect-error bender url */
import hsLogoDark from 'bender-url!../../img/hubspot-tools-logo-dark.svg';
import LiveChatSample from './LiveChatSample';
import { Paths } from './Routes';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import { useDispatch } from 'react-redux';
import { UsageTrackerUtils } from 'feature-unboxing-common';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  TrackerActions
} = UsageTrackerUtils;
const RedirectButton = styled.button.withConfig({
  displayName: "LandingPage__RedirectButton",
  componentId: "sc-3k4c28-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return Object.assign({}, theme.typography['body-200'], {
    lineHeight: '28px',
    fontWeight: '500',
    width: '175px',
    height: '55px',
    borderRadius: '8px !important',
    backgroundColor: '#ff5c35',
    color: `${theme.color['text-core-on-fill-default']} `,
    border: 'none',
    '&:hover': {
      backgroundColor: '#e04826'
    },
    '&:active': {
      backgroundColor: '#b3361d'
    }
  });
});
const LiveChatBackground = styled.div.withConfig({
  displayName: "LandingPage__LiveChatBackground",
  componentId: "sc-3k4c28-1"
})(() => {
  return {
    backgroundImage: `url(${liveChatBg})`,
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    paddingRight: '15%',
    paddingLeft: '15%'
  };
});
function LandingPage() {
  const {
    search
  } = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    dispatch(TrackerActions.trackPageView({
      screen: 'landing-page'
    }));
  }, [dispatch]);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "INDEX_LOAD",
    children: /*#__PURE__*/_jsx(View, {
      blockSize: "100vh",
      maxInlineSize: "1440px",
      margin: "auto",
      overflowX: "hidden",
      paddingInline: "400",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        blockSize: "100vh",
        children: [/*#__PURE__*/_jsx(Flex, {
          flexDirection: "row",
          flexGrow: 1,
          children: /*#__PURE__*/_jsxs(Grid, {
            children: [/*#__PURE__*/_jsx(GridItem, {
              size: {
                md: 6,
                sm: 12
              },
              children: /*#__PURE__*/_jsx(Flex, {
                blockSize: "100%",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingBlock: "1000",
                children: /*#__PURE__*/_jsxs(View, {
                  maxInlineSize: "500px",
                  children: [/*#__PURE__*/_jsx(View, {
                    marginBlockEnd: "1100",
                    children: /*#__PURE__*/_jsx("img", {
                      src: hsLogoDark,
                      alt: "HubSpot"
                    })
                  }), /*#__PURE__*/_jsx(Text, {
                    typography: "heading-1000",
                    marginBlockEnd: "600",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "app.landingPage.title"
                    })
                  }), /*#__PURE__*/_jsx(Text, {
                    as: "h3",
                    marginBlockEnd: "500",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "app.landingPage.subtitle"
                    })
                  }), /*#__PURE__*/_jsx(RedirectButton, {
                    onClick: () => {
                      history.push(Paths.FIRST_STEP, {
                        search
                      });
                    },
                    "data-test-id": "start-button",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "app.landingPage.start"
                    })
                  })]
                })
              })
            }), /*#__PURE__*/_jsx(GridItem, {
              size: {
                md: 6,
                sm: 12
              },
              children: /*#__PURE__*/_jsx(Flex, {
                blockSize: "100%",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingBlock: "1000",
                children: /*#__PURE__*/_jsx(LiveChatBackground, {
                  children: /*#__PURE__*/_jsx(Flex, {
                    alignItems: "center",
                    justifyContent: "center",
                    children: /*#__PURE__*/_jsx(LiveChatSample, {})
                  })
                })
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "800",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "app.landingPage.copyright",
            options: {
              year: new Date().getFullYear().toString()
            }
          })
        })]
      })
    })
  });
}
export default styled(LandingPage).withConfig({
  displayName: "LandingPage",
  componentId: "sc-3k4c28-2"
})(["height:100vh;h1{font-size:60px;}h3{font-size:22px;}"]);